module.exports = __webpack_public_path__ + "img/supplier-001.f148e83c.png";